export const getFullUrl = path => {
  const domain = process.env.GATSBY_DOMAIN || ''
  const prefix = process.env.GATSBY_PATH_PREFIX || ''
  const formattedPrefix = prefix && `/${prefix}`
  return `${domain}${formattedPrefix}${path}`
}

export const changeUrlLanguage = (url, currentLanguage, newLanguage) => {
  const regex = new RegExp(`/${currentLanguage}(/|$)`)
  return url.replace(regex, `/${newLanguage}/`)
}

export const changeUrlVersion = (url, currentVersion, newVersion) => {
  const regex = new RegExp(`/${currentVersion}(/|$)`);
  return url.replace(regex, `/${newVersion}/`)
};

export const getLanguageFromUrl = url => {
  const possibleLanguages = ['en', 'pt-BR', 'es']
  let language = 'pt-BR'

  possibleLanguages.forEach(lang => {
    if (url.indexOf(`/${lang}/`) !== -1) {
      language = lang
    }
  })

  return language
}

export const getVersionFromUrl = (url, possibleVersions) => {
  let version = 'v1';

  possibleVersions.forEach(ver => {
    if (url.indexOf(`/${ver}/`) !== -1) {
      version = ver;
    }
  });

  return version;
}
